/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

// generate prototype of Error
import BaseError from './BaseError';
import {AxiosError} from 'axios';

/**
 * CORS exception type.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
export default class CorsException extends BaseError {
    constructor(public axiosError: AxiosError) {
        super();
    }
}
